import React from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
// Material-ui components
import { MenuList, MenuItem,Typography } from "@material-ui/core";
// Material-ui icons

import styles from "./styles";

import { labelFromPath } from "Utils";

function ChatSelectorRender(props) {
    const classes = styles();
    const {list, action} = props;

    function displayItem(item){
        action(item[1].uid,true)
    }

    const _label = key => labelFromPath(props.labelPath, key, props.lang);

    return (
      <div className={classes.root}>
        <Typography variant="h6">{_label("available")}</Typography>
        <MenuList className={classes.menuList}>
        {Object.entries(list).map((item) => (
          <MenuItem key={item[0]} onClick={e => displayItem(item)}>
            <div className={classes.item}>
              {item[1].name}
            </div>
          </MenuItem>
        ))}
        </MenuList>
      </div>
    );
  }
  
  /**
   * Export component
   */
  // map redux state to props
  export default connect(state => ({
    lang: state.locale.lang
  }))(ChatSelectorRender);
  